import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TopicEditRoutingModule } from "@onsip/web/features/sayso/saysoSettings/topicEdit/topic-edit-routing.module";
import { SaysoTopicEditComponent } from "@onsip/web/features/sayso/saysoSettings/topicEdit/sayso-topic-edit.component";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { TopicWriteFormModule } from "@onsip/web/features/sayso/saysoSettings/topicWriteForm/topic-write-form.module";
import { MaterialModule } from "@onsip/web/modules/material/material.module";
import { OnsipFormsModule } from "@onsip/web/features/shared/components/forms/onsip-forms.module";
import { HeaderModule } from "@onsip/web/features/shared/components/layout/header/header.module";
import { PipesModule } from "@onsip/web/features/shared/pipes/pipes.module";

@NgModule({
  declarations: [SaysoTopicEditComponent],
  imports: [
    CommonModule,
    TopicEditRoutingModule,
    ReactiveFormsModule,
    OnsipFormsModule,
    HeaderModule,
    TranslateModule,
    PipesModule,
    TopicWriteFormModule,
    MaterialModule
  ]
})
export class TopicEditModule {}
